import {Customization} from '@eduvision/toolkit';

export const routes: Customization['routes'] = {
  // customRoutes: [...customRoutes]
  // customAdminRoutes: [...customAdminRoutes]
};
